'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _events = require('events');

var _stringify = require('./stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extractError = require('./extract-error');

var _extractError2 = _interopRequireDefault(_extractError);

var _dalError = require('./dal-error');

var REQUEST_ID_HEADER_NAME = 'x-cpinternalrequestid';

var AbstractClient = (function (_EventEmitter) {
  _inherits(AbstractClient, _EventEmitter);

  function AbstractClient(credentials) {
    var apiBase = arguments.length <= 1 || arguments[1] === undefined ? 'https://api.classpass.com' : arguments[1];

    _classCallCheck(this, AbstractClient);

    _get(Object.getPrototypeOf(AbstractClient.prototype), 'constructor', this).call(this);

    if (!credentials) {
      throw new Error('No credentials provided');
    }

    this.credentials = credentials;
    this.apiBase = apiBase;
    this.headers = {};
  }

  _createClass(AbstractClient, [{
    key: 'setToken',
    value: function setToken(token) {
      this.credentials.token = token;
    }
  }, {
    key: 'getToken',
    value: function getToken() {
      return this.credentials.token;
    }
  }, {
    key: 'setHeader',
    value: function setHeader(key, value) {
      this.headers[key] = value;
    }
  }, {
    key: 'request',
    value: function request(method, url, params, overrides, name) {
      var _this = this;

      var startAt = Date.now();

      this.emit('request', {
        name: name,
        method: method,
        url: url,
        params: params,
        overrides: overrides,
        startAt: startAt
      });

      return this.sendRequest(method, url, params, overrides).then(function (resp) {
        var endAt = Date.now();
        var contentType = resp.headers && resp.headers['content-type'] || '';
        var isEmptyBody = !(resp.body || '').trim();
        var isJsonReponse = contentType.indexOf('application/json') !== -1;
        var status = parseInt(resp.status, 10);
        var is2xxResponse = status >= 200 && status < 300;
        var data = undefined;

        if (resp.wasNetworkTimeout) {
          throw new _dalError.DALNetworkTimeoutError('api request timed out', '', {
            method: method,
            endpoint: name,
            path: url
          });
        }

        if (isJsonReponse && !isEmptyBody) {
          try {
            data = JSON.parse(resp.body);
          } catch (err) {
            throw new _dalError.DALJsonParseError('could not parse response as JSON', '', {
              code: 1,
              method: method,
              endpoint: name,
              path: url,
              httpStatus: resp.status,
              requestId: resp.headers[REQUEST_ID_HEADER_NAME]
            });
          }
        }

        if (!is2xxResponse) {
          if (data) {
            var error = (0, _extractError2['default'])(data);
            if (error) {
              var ErrorClass = (0, _dalError.statusToErrorClass)(resp.status);
              throw new ErrorClass(error.message, error.details, {
                code: error.code,
                method: method,
                endpoint: name,
                path: url,
                httpStatus: resp.status,
                requestId: resp.headers[REQUEST_ID_HEADER_NAME]
              });
            } else {
              throw new _dalError.DALNoErrorError('got ' + resp.status + '-status JSON response from API without error', '', {
                code: 3,
                method: method,
                endpoint: name,
                path: url,
                httpStatus: resp.status,
                requestId: resp.headers[REQUEST_ID_HEADER_NAME]
              });
            }
          } else {
            var ErrorClass = (0, _dalError.statusToErrorClass)(resp.status, _dalError.DALNoDataError);
            throw new ErrorClass('got ' + resp.status + '-status ' + contentType + ' response from API without data', '', {
              code: resp.status || 2,
              method: method,
              endpoint: name,
              path: url,
              httpStatus: resp.status,
              requestId: resp.headers[REQUEST_ID_HEADER_NAME]
            });
          }
        }

        _this.emit('success', {
          name: name,
          method: method,
          url: url,
          params: params,
          overrides: overrides,
          size: (resp.body || '').length,
          httpStatus: resp.status,
          requestId: resp.headers && resp.headers[REQUEST_ID_HEADER_NAME],
          startAt: startAt,
          endAt: endAt,
          duration: endAt - startAt
        });

        return data;
      })['catch'](function (err) {
        var endAt = Date.now();
        var error = undefined;

        if (err instanceof _dalError.DALError) {
          error = err;
        } else {
          error = new Error('DAL transport error: ' + (err.message || err));
          error.stack = err.stack;
        }

        _this.emit('failure', {
          name: name,
          method: method,
          url: url,
          params: params,
          overrides: overrides,
          httpStatus: err.httpStatus || 0,
          code: error.code || 0,
          startAt: startAt,
          endAt: endAt,
          duration: endAt - startAt,
          requestId: err.requestId
        });

        throw error;
      });
    }
  }, {
    key: 'get',
    value: function get(url, params, overrides, name) {
      return this.request('GET', url + (params ? '?' + (0, _stringify2['default'])(params, !!(overrides && overrides.brackets)) : ''), null, overrides, name);
    }
  }, {
    key: 'post',
    value: function post(url, params, overrides, name) {
      return this.request('POST', url, params, overrides, name);
    }
  }, {
    key: 'put',
    value: function put(url, params, overrides, name) {
      return this.request('PUT', url, params, overrides, name);
    }
  }, {
    key: 'delete',
    value: function _delete(url, params, overrides, name) {
      return this.request('DELETE', url, params, overrides, name);
    }
  }, {
    key: 'patch',
    value: function patch(url, params, overrides, name) {
      return this.request('PATCH', url, params, overrides, name);
    }
  }]);

  return AbstractClient;
})(_events.EventEmitter);

exports['default'] = AbstractClient;
module.exports = exports['default'];